import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Products & Services", path: "/products" },
  { label: "Gallery", path: "/gallery" },
  { label: "Testimonials", path: "/testimonials" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const transparent = isHome && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        transparent
          ? "bg-transparent"
          : "bg-white border-b border-stone-100"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 flex-shrink-0 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/d9440b223e6d80ac031633973d3203ba/a4e24dd15d398814f0f972e0887c314a.png"
            alt="Ensure Windows Logo"
            className="h-12 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => {
            const active = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm font-medium tracking-wide transition-colors duration-200 whitespace-nowrap rounded-md cursor-pointer ${
                  transparent
                    ? active
                      ? "text-amber-400"
                      : "text-white hover:text-amber-300"
                    : active
                    ? "text-amber-600"
                    : "text-zinc-700 hover:text-amber-600"
                }`}
                style={{ fontFamily: "'Raleway', sans-serif" }}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>

        {/* Right CTA */}
        <div className="hidden lg:flex items-center gap-4">
          <a
            href="tel:07852636300"
            className={`flex items-center gap-2 text-sm font-semibold whitespace-nowrap cursor-pointer ${transparent ? "text-white" : "text-zinc-800"}`}
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-phone-fill text-amber-500 text-lg"></i>
            </div>
            07852 636 300
          </a>
          <Link
            to="/contact"
            className="bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold px-5 py-2.5 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            Free Quote
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${transparent ? "text-white" : "text-zinc-800"}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-3-line"} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-stone-100 shadow-lg">
          <nav className="flex flex-col py-4 px-6 gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="py-3 px-4 text-sm font-medium text-zinc-700 hover:text-amber-600 hover:bg-stone-50 rounded-md transition-colors cursor-pointer"
                style={{ fontFamily: "'Raleway', sans-serif" }}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-3 border-t border-stone-100 mt-2 flex flex-col gap-3">
              <a href="tel:07852636300" className="flex items-center gap-2 text-sm font-semibold text-zinc-800 cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-amber-500"></i></div>
                07852 636 300
              </a>
              <Link to="/contact" className="bg-amber-600 text-white text-sm font-semibold px-5 py-2.5 rounded-md text-center cursor-pointer">
                Get a Free Quote
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
